const colorToken = {
	mark: "color",
	getAttrs: (tok) => tok.attrs,
};

export default colorToken;
